import React, { useState, useEffect, useCallback } from 'react';
import { localToday } from '../../utils/dateUtils';
import './saude.css';
import Sidebar from '../../components/Sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import { useInternals } from '../../context/internalContext';
import { useAuxiliaries } from '../../context/auxiliariesContext';
import { useUsers } from '../../context/usersContext';
import { toast } from 'react-toastify';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import PageHeader from '../../components/PageHeader';
import SearchInternal from '../../components/SearchInternal/SearchInternal';
import InternalDataSkeleton from '../../components/InternalDataSkeleton';
import useSubmitLock from '../../utils/useSubmitLock';


// Dados de Vacinação
const initializeVaccinationData = () => ({
  date: localToday(),
  vaccination: '',
  dosage: '',
  batch: '',
  expiration: '',
  manufacturing_date: '',
  observation: '',
  internal: '',
});

const Vacina = () => {
  const location = useLocation();
  const { internalId } = location.state || {};
  const { userInfo, effectiveUnitId, buildUnitReadParams } = useUsers();

  // --- Estados para os formulários ---
  const [vaccinationData, setVaccinationData] = useState(() => initializeVaccinationData()); // Inicializa com objeto

  const [vaccinationRecords, setVaccinationRecords] = useState([]);


  // --- Estados para listas auxiliares ---
  const [vaccinations, setVaccinations] = useState([]);


  // Funções de requisição (já existentes no contexto de internos)
  const {
    listInternals,
    listVaccinationsByInternal,
    createVaccination,

  } = useInternals();

  // Funções auxiliares para carregar opções (vacinas, remédios, etc.)
  const { listVaccinations } = useAuxiliaries();

  // --- Estados de busca e dados do interno selecionado ---
  const [internalDetails, setInternalDetails] = useState(null);
  const [isSelectingInternal, setIsSelectingInternal] = useState(false);
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();

  // Abas: 'dados', 'vacina', 'medicamentos', 'externo', 'evolucao', 'exames'
  const [currentTab, setCurrentTab] = useState('vacina');



  // --- Carrega dados auxiliares ---
  const loadAuxiliaryData = useCallback(async () => {
    try {
      const vaccinationsData = await listVaccinations();
      setVaccinations(vaccinationsData?.results || []);

    } catch (error) {
      console.error('Erro ao carregar dados auxiliares:', error);
    }
  }, [listVaccinations]);

  // --- Seleção de Interno e carregamento dos dados já cadastrados ---
  const handleInternalSelect = useCallback(async (internal) => {
    if (!internal?.id) {
      toast.error("Erro ao selecionar interno.");
      return;
    }

    try {
      const vaccinationsRes = await listVaccinationsByInternal(internal.id, '2025-01-01');
      setVaccinationRecords(vaccinationsRes?.results || vaccinationsRes || []);

      setInternalDetails(internal);

      setVaccinationData(prev => ({
        ...prev,
        internal: internal.id,
        health_professional: userInfo.id,
      }));

      setVaccinationRecords(vaccinationsRes?.results || []);


    } catch (error) {
      console.error('Erro ao carregar dados do interno:', error);
      toast.error('Erro ao carregar dados do interno.');
    }
  }, [listVaccinationsByInternal, userInfo]);


  useEffect(() => {
    if (internalId) {
      handleInternalSelect({ id: internalId });
    }
  }, [internalId, handleInternalSelect]);


  const handleVaccinationInputChange = (e) => {
    const { name, value } = e.target;
    setVaccinationData(prev => ({
      ...prev,
      [name]: value
    }));
  };



  const handleVaccinationSubmit = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      if (!vaccinationData.internal) {
        toast.error('Nenhum interno selecionado.');
        return;
      }

      try {
        const vacPayload = {
          ...vaccinationData,
          health_professional: userInfo.id
        };

        await createVaccination(vacPayload);

        const updatedRecords = await listVaccinationsByInternal(vaccinationData.internal);
        setVaccinationRecords(updatedRecords?.results || updatedRecords || []);

        setVaccinationData(initializeVaccinationData());

      } catch (error) {
        console.error('Erro ao registrar vacinação:', error);
      }
    });
  };


  // --- Efeitos para carregar dados ---
  useEffect(() => {
    if (effectiveUnitId !== null && effectiveUnitId !== undefined && String(effectiveUnitId) !== '') {
      loadAuxiliaryData();
    }
  }, [loadAuxiliaryData, effectiveUnitId]);

  useEffect(() => {
    if (internalId) {
      const fetchInternalById = async () => {
        try {
          const response = await listInternals(buildUnitReadParams({ id: internalId }));
          const internalData = response?.results?.[0];

          if (internalData) {
            handleInternalSelect(internalData)
          }
        } catch (error) {
          console.error("Erro ao carregar interno pelo ID:", error);
          toast.error("Erro ao carregar interno.");
        }
      };

      fetchInternalById();
    }
  }, [internalId, handleInternalSelect, listInternals, buildUnitReadParams]);
  // --- Renderização das abas ---
  const renderVacinaTab = () => (
    <div className="vacina-container">
      <form onSubmit={handleVaccinationSubmit} className="evolucao-container">
        <div className="social-form-group-duplo">
          <div className="social-form-group">
            <label>Data da Vacinação</label>
            <input
              type="date"
              name="date"
              value={vaccinationData.date || ''}
              onChange={handleVaccinationInputChange}
            />
          </div>
          <div className="social-form-group">
            <label>Vacina</label>
            <select name="vaccination" value={vaccinationData.vaccination} onChange={handleVaccinationInputChange}>
              <option value="">Selecione</option>
              {vaccinations.map(vac => (
                <option key={vac.id} value={vac.id}>{vac.name}</option>
              ))}
            </select>
          </div>
          <div className="social-form-group">
            <label>Dose</label>
            <select name="dosage" value={vaccinationData.dosage} onChange={handleVaccinationInputChange}>
              <option value="">Selecione</option>
              <option value="ÚNICO">ÚNICO</option>
              <option value="PRIMEIRA">PRIMEIRA</option>
              <option value="SEGUNDA">SEGUNDA</option>
              <option value="TERCEIRA">TERCEIRA</option>
              <option value="PRIMEIRA DOSE REFORÇO">PRIMEIRA DOSE REFORÇO</option>
              <option value="SEGUNDA DOSE REFORÇO">SEGUNDA DOSE REFORÇO</option>
              <option value="TERCEIRA DOSE REFORÇO">TERCEIRA DOSE REFORÇO</option>
            </select>
          </div>
        </div>
        <div className="social-form-group-duplo">
          <div className="social-form-group">
            <label>Lote da vacina</label>
            <input
              type="text"
              name="batch"
              value={vaccinationData.batch}
              onChange={handleVaccinationInputChange}
            />
          </div>
          <div className="social-form-group">
            <label>Validade da vacina</label>
            <input
              type="date"
              name="expiration"
              value={vaccinationData.expiration}
              onChange={handleVaccinationInputChange}
            />
          </div>
          <div className="social-form-group">
            <label>Fabricação da vacina</label>
            <input
              type="date"
              name="manufacturing_date"
              value={vaccinationData.manufacturing_date}
              onChange={handleVaccinationInputChange}
            />
          </div>
        </div>
        <div className="social-form-group">
          <label>Observação</label>
          <textarea
            name="observation"
            rows="3"
            value={vaccinationData.observation}
            onChange={handleVaccinationInputChange}
          />
        </div>
        <div className="social-form-group">
          <button type="submit" className="social-submit-button" disabled={isSubmitting}>
            {isSubmitting ? 'Salvando...' : 'Salvar Vacinação'}
          </button>
        </div>
      </form>
      {/* Timeline com os registros cadastrados */}
      <div className="timeline">
        <h4>Histórico de Vacinação</h4>
        <ul className="timeline-list">
          {vaccinationRecords.length > 0 ? (
            vaccinationRecords.map((vac, index) => (
              <li key={index} className="timeline-item">
                <div className="timeline-date">
                  <FontAwesomeIcon icon={faClock} /> {new Date(vac.date).toLocaleDateString()}
                </div>
                <div className="timeline-content">
                  <p><strong>Vacina:</strong> {vac.vaccination_name || 'Não informado'}</p>
                  <p><strong>Dosagem:</strong> {vac.dosage || 'Não informado'}</p>
                  <p><strong>Lote:</strong> {vac.batch || 'Não informado'}</p>
                  <p><strong>Data de Validade:</strong> {vac.expiration ? new Date(vac.expiration).toLocaleDateString() : 'Não informado'}</p>
                  <p><strong>Data de Fabricação:</strong> {vac.manufacturing_date ? new Date(vac.manufacturing_date).toLocaleDateString() : 'Não informado'}</p>
                  <p><strong>Observação:</strong> {vac.observation || 'Sem observação'}</p>
                </div>
              </li>
            ))
          ) : (
            <p>Nenhum registro de vacinação.</p>
          )}
        </ul>
      </div>
    </div>
  );


  const renderTabContent = () => {
    switch (currentTab) {
      case 'vacina':
        return renderVacinaTab();
      default:
        return null;
    }
  };

  // --- Renderização principal do componente ---
  return (
    <div>
      <Sidebar />
      <Header />
      <div className="container social-container admission-page">
        <Titulo
          children={
            <SearchInternal
              onSelect={handleInternalSelect}
              onSelectingChange={setIsSelectingInternal}
            />
          }
        />

        <PageHeader
          title="Vacinação"
          subtitle="Histórico de vacinas e registros aplicados."
          internalDetails={internalDetails}
        />

        {isSelectingInternal ? (
          <InternalDataSkeleton />
        ) : (
          <>
        <div className="social-tabs">
          <button className={`social-tab-button ${currentTab === 'vacina' ? 'active' : ''}`} onClick={() => setCurrentTab('vacina')}>Vacinação</button>
        </div>

        <div className="social-tab-content">
          {renderTabContent()}
        </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Vacina;
